import type { LessonDialogState } from './types';

export const initialLessonDialogState: LessonDialogState = {
  loadingDialogIsOpen: false,
  loadingDialogTitle: '',
  loadingDialogState: 'loading',
  loadingDialogOpenTimestamp: 0
};
